import React from 'react';
import { View } from 'react-native';
import RenderHtml from 'react-native-render-html';
import { useWindowDimensions } from 'react-native';
import LinearGradient from 'react-native-linear-gradient';
import GiftIconOpen from '@assets/svg/GiftIconOpen';
import { scale, ScaledSheet } from '@utils/scale';

interface IncentiveReceivedProps {
  htmlContent: string;
}

/**
 * IncentiveReceived Component
 * Displays incentive received message with HTML content
 */
const IncentiveReceived: React.FC<IncentiveReceivedProps> = ({ htmlContent }) => {
  const { width } = useWindowDimensions();

  return (
    <View style={styles.wrapper}>
      <LinearGradient
        colors={['#02BC7D', '#204F33']}
        start={{ x: 0, y: 0 }}
        end={{ x: 1, y: 0 }}
        style={styles.container}
      >
        <View style={styles.iconContainer}>
          <GiftIconOpen width={scale(28)} height={scale(28)} />
        </View>
        <View style={styles.contentContainer}>
          <RenderHtml
            html={htmlContent}
            imagesMaxWidth={width - 120}
            tagsStyles={{
              body: {
                color: '#FFFFFF',
                fontSize: 16,
                fontWeight: '600',
                margin: 0,
                padding: 0,
              },
              p: {
                margin: 0,
                padding: 0,
                lineHeight: 22,
              },
              span: {
                color: '#7BFFAF',
                fontWeight: '700',
              },
              strong: {
                color: '#FFFFFF',
                fontWeight: '700',
              },
            }}
          />
        </View>
      </LinearGradient>
    </View>
  );
};

const styles = ScaledSheet.create({
  wrapper: {
    borderWidth: 2,
    borderColor: '#FFFFFF',
    borderRadius: 20,
    overflow: 'hidden',
    marginHorizontal: 12,
    marginBottom: 12,
  },
  container: {
    flexDirection: 'row',
    alignItems: 'center',
    borderRadius: 20,
    padding: 8,
  },
  iconContainer: {
    width: scale(44),
    height: scale(44),
    borderRadius: scale(28),
    backgroundColor: '#FFFFFF',
    justifyContent: 'center',
    alignItems: 'center',
    marginRight: 8,
    marginVertical: 8,
  },
  contentContainer: {
    flex: 1,
  },
});

export default IncentiveReceived;
